// Everything that is the same in both modes sits outside the colorScheme. The
// padding used to live there and differed (12px light, 15px dark), so the tab
// bar changed height by 6px on every theme switch (MOG-4370).
export const tabsTheme = {
  root: {
    transitionDuration: '0.2s'
  },
  tablist: {
    borderWidth: '0',
    background: 'transparent',
    borderColor: 'transparent'
  },
  tab: {
    background: 'transparent',
    hoverBackground: 'transparent',
    activeBackground: 'transparent',
    borderWidth: '0',
    borderColor: 'transparent',
    padding: '15px 16px',
    fontWeight: '700',
    margin: '0',
    gap: '0',
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none'
    }
  },
  tabpanel: {
    background: 'transparent',
    color: '{text.color}',
    padding: '0',
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none'
    }
  },
  navButton: {
    background: 'transparent',
    width: '2.5rem',
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none'
    }
  },
  activeBar: {
    height: '2px',
    bottom: '0'
  },
  colorScheme: {
    light: {
      tab: {
        hoverBorderColor: '{gray.900}',
        activeBorderColor: '{gray.900}',
        color: '{gray.500}',
        hoverColor: '{gray.900}',
        activeColor: '{gray.900}'
      },
      navButton: {
        color: '{gray.500}',
        hoverColor: '{gray.900}',
        // Stays per mode: Aura sets this shadow per mode, which would win over
        // a shared value.
        shadow: 'none'
      },
      activeBar: {
        background: '{gray.900}'
      }
    },
    dark: {
      tab: {
        hoverBorderColor: '{gray.0}',
        activeBorderColor: '{gray.0}',
        color: '{gray.400}',
        hoverColor: '{gray.0}',
        activeColor: '{gray.0}'
      },
      navButton: {
        color: '{gray.400}',
        hoverColor: '{gray.0}',
        shadow: 'none'
      },
      activeBar: {
        background: '{gray.0}'
      }
    }
  }
};
